const FallbackImage = function(number){
    const nrOfImages = 14;

    if(!number) {
        number = Math.floor(Math.random() * nrOfImages);
    }

    return `/img/alternative/alternative_${number % (nrOfImages + 1)}.jpg`;
}

export default FallbackImage;